import { Link } from "react-router-dom";
import { articles } from "@/mocks/article";

const featuredArticle = articles["cssbuy-spreadsheet-ultimate-guide"];

export default function ArticleTeaser() {
  if (!featuredArticle) return null;

  const { meta } = featuredArticle;

  return (
    <section id="guides" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-[55%]">
            <span className="inline-block px-3 py-1.5 bg-secondary-100 text-foreground-700 text-[11px] font-medium tracking-[0.05em] uppercase rounded-md mb-6">
              Buyer&apos;s Guide
            </span>
            <h2 className="text-[36px] md:text-[44px] font-bold text-foreground-950 font-heading leading-[1.12]">
              CSSBuy Sheet
              <br />
              Explained
              <br />
              For Beginners
            </h2>
            <p className="mt-6 text-[15px] text-foreground-500 leading-relaxed max-w-[480px]">
              Learn everything about CSSBuy spreadsheets — how they work, why they save you money, and where to find the most updated product lists for agent shopping in 2026.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to={`/article/${meta.slug}`}
                className="inline-flex items-center gap-2 h-11 px-6 bg-foreground-900 text-background-50 rounded-lg text-[14px] font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="#categories"
                className="inline-flex items-center gap-2 h-11 px-6 bg-background-50 border border-secondary-300 text-foreground-700 rounded-lg text-[14px] font-medium hover:border-foreground-400 transition-colors duration-200 whitespace-nowrap"
              >
                Browse Categories
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 h-11 px-6 bg-background-50 border border-secondary-300 text-foreground-700 rounded-lg text-[14px] font-medium hover:border-foreground-400 transition-colors duration-200 whitespace-nowrap"
              >
                Visit Main Site
              </a>
            </div>
          </div>

          <div className="lg:w-[45%]">
            <Link
              to={`/article/${meta.slug}`}
              className="block group cursor-pointer"
            >
              <div className="relative rounded-3xl bg-accent-500/20 p-8 md:p-10 min-h-[340px] flex flex-col justify-between overflow-hidden transition-all duration-300 group-hover:-translate-y-1">
                <span className="text-[11px] font-medium text-accent-700/70 tracking-[0.04em] uppercase">
                  Featured Read
                </span>

                <div className="mt-auto">
                  <p className="text-[19px] md:text-[21px] font-medium text-foreground-900 leading-relaxed font-heading">
                    &ldquo;{meta.excerpt.slice(0, 140)}&hellip;&rdquo;
                  </p>

                  <div className="mt-8 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-accent-500/30 flex items-center justify-center">
                        <i className="ri-article-line text-accent-700 text-lg w-5 h-5 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <p className="text-[13px] font-medium text-foreground-800">{meta.title.slice(0, 40)}&hellip;</p>
                        <p className="text-[11px] text-foreground-500">Updated {meta.date}</p>
                      </div>
                    </div>
                    <div className="w-10 h-10 rounded-xl bg-background-50/60 flex items-center justify-center group-hover:bg-background-50 transition-colors duration-200">
                      <i className="ri-arrow-right-line text-foreground-700 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                  </div>
                </div>

                <div className="absolute top-8 right-8 flex gap-1.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-background-50/50"></div>
                  <div className="w-1.5 h-1.5 rounded-full bg-background-50/50"></div>
                  <div className="w-1.5 h-1.5 rounded-full bg-background-50/50"></div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}